module.exports = __webpack_public_path__ + "img/FenXiang.497ccc5f.svg";